import { LmfAnalyticsProvider } from '@syconium/little-miss-figgy/dist/components/Analytics/LmfAnalyticsProvider'
import { ApolloClientProfile } from '@syconium/weeping-figs'

import { PrimaryNavWelcomeDialog } from '../../../app/_components/chrome/PrimaryNavWelcome.client'
import { CartInterstitialAndOverlay } from '../../../app/_components/dialogs/CartInterstitialAndOverlay.client'
import { useCartRecovery } from '../../../app/_hooks/useCartRecovery'
import { useLoop } from '../../../app/_providers/LoopProvider.client'
import { FETCH_SITE_FIXTURES } from '../../../lib/graphql/queries/FETCH_SITE_FIXTURES'
import { singleQueryParamValue } from '../../../lib/utils'
import { UnsupportedBanner } from '../../chrome/UnsupportedBanner'
import { NavFooter } from '../../nav/NavFooter'
import { NavHeader } from '../../nav/NavHeader'
import { PromoBarFromContext } from '../../nav/PromoBar'
import { SkipToMainContentLink } from '../../nav/SkipToMainContentLink'
import { MiniCartAndOverlay } from '../../pages/cart/MiniCartAndOverlay/MiniCartAndOverlay'
import { SearchOverlay } from '../../pages/search/Search/SearchOverlay'
import { PageLayoutConfig } from '../types'

interface PrimaryLayoutProps {
  children?: React.ReactNode
}

function PrimaryLayout({ children }: PrimaryLayoutProps) {
  useCartRecovery()
  const { inLoopFlow } = useLoop()

  return (
    <>
      <SkipToMainContentLink />

      <UnsupportedBanner />

      <SearchOverlay />

      <LmfAnalyticsProvider title='Header'>
        {!inLoopFlow && <PromoBarFromContext />}

        <NavHeader />

        <MiniCartAndOverlay />
        <CartInterstitialAndOverlay />
      </LmfAnalyticsProvider>

      <LmfAnalyticsProvider title='Body'>
        {children}
        <LmfAnalyticsProvider title='Welcome Dialog'>
          <PrimaryNavWelcomeDialog />
        </LmfAnalyticsProvider>
      </LmfAnalyticsProvider>

      <LmfAnalyticsProvider title='Footer'>
        <NavFooter />
      </LmfAnalyticsProvider>
    </>
  )
}

export const primaryLayoutConfig: PageLayoutConfig = {
  Layout: ({ content, options: _options }) => <PrimaryLayout>{content}</PrimaryLayout>,
  preloadDataForLayout: pageContext => {
    const content = singleQueryParamValue(pageContext.query.content)
    const preview = content === 'preview'
    const contentClient = pageContext.apolloClientFactory.for(
      ApolloClientProfile.FigsPublicSupergraph
    )

    return contentClient.query({
      query: FETCH_SITE_FIXTURES,
      variables: { handle: 'default', preview },
    })
  },
}
